// A task's picked date is its UTC date; overdue is based on the partners' Eastern today.
import { easternDay } from '../../modules/q2c/eastern-day.mjs';

export function dueDay(dueAt) {
  if (dueAt === null || dueAt === undefined || dueAt === '') return '';
  try {
    const date = new Date(dueAt);
    return Number.isNaN(date.getTime()) ? '' : date.toISOString().slice(0, 10);
  } catch {
    return '';
  }
}

export function dueLabel(dueAt) {
  const day = dueDay(dueAt);
  return day ? new Date(`${day}T00:00:00Z`).toLocaleDateString(undefined, { timeZone: 'UTC' }) : '';
}

function addDays(day, count) {
  const [year, month, date] = day.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, date + count)).toISOString().slice(0, 10);
}

// Group a picked due date against the partners' Eastern today.
export function dueBucket(dueAt, now = new Date()) {
  const due = dueDay(dueAt);
  const today = easternDay(now);
  if (due === '' || today === '') return 'none';
  if (due < today) return 'overdue';
  if (due === today) return 'today';
  if (due < addDays(today, 7)) return 'week';
  return 'later';
}

export function isOverdue(dueAt, now = new Date()) {
  const due = dueDay(dueAt);
  const today = easternDay(now);
  return due !== '' && today !== '' && due < today;
}
